export default {
	header: {
		buy_tickets: 'Buy tickets',
		hamburger: {
			open_arialabel: 'Open mobile menu',
			close_arialabel: 'Close mobile menu'
		}
	},
	imecwebsite: 'https://www.imec-int.com/',
	open: 'Open',
	close: 'Close',
	share: 'Share on',
	languages: 'Languages',
	footer: {
		copyright: '© 2018 Codeurs, All rights reserved.'
	},
	shopbasket: {
		title: {
			nolength: 'Did you know you get a discount when you buy a full package?',
			length: 'Your selection'
		},
		totalprice: 'Total price (Excl. VAT)'
	},
	details: {
		firstname: 'First name',
		lastname: 'Last name',
		email: 'E-mail attendee',
		email_new: 'New E-mail attendee',
		not_affiliated: 'I am not affiliated with a company',

		function: 'Function title',
		company: 'Company',
		company_belgian:
			'I work for a Flemish company, the Flemish government, an innovation center, a town or municipality in Flanders',
		company_belgian_popup_label: 'Demo tours',
		company_belgian_popup:
			"Imec organizes thematic demo tours (some including a workshop) for Flemish companies and organizations to better meet their needs. This is part of imec's mission to assist Flemish companies and organizations in their innovation processes.",
		kp: 'KP number',
		kp_help: `
			Don't know your KP number? You can find a list with KP numbers <a href="http://imecwww.imec.be/wwwintra/ImecUser/Documents/sap/kp.html" target="_blank">here</a>.
		`,
		industry: 'Which industry are you in?',
		industry_description: 'Describe this industry',
		industries: [
			'Aerospace',
			'Automotive',
			'Biotech, Life Science, and Pharma companies',
			'Consumer Electronics & Infotainment',
			'Datacom & Telecom',
			'Display Companies',
			'Energy Companies',
			'Equipment & Material Suppliers',
			'Fabless, Light, System and EDA Companies',
			'Food and Agriculture',
			'Funding Authorities & Government',
			'Imaging & Vision System Companies',
			'Integrated Device Manufacturers & Mainstream Foundries',
			'IoT Companies',
			'Medical Devices',
			'Security & Surveillance',
			'Specialty Foundry and IC Makers',
			'Universities and R&D Centers',
			'Press / Media',
			'Other',
			'Venturing',
			'I am not affiliated with a company'
		],
		street: 'Street',
		number: 'Number',
		box: 'Box',
		postal_code: 'Postal code',
		city: 'City',
		state: 'State',
		country: 'Country',
		phone: 'Phone',
		website: 'Website',
		vat: 'VAT n°',
		vat_help: 'If not applicable, please enter NONE.',
		vat_not_applicable: 'VAT number not applicable',

		other_invoice_address: 'Use a different invoice address',
		invoice_address: 'Invoice address',
		invoice_address_line2: 'Invoice address line 2',
		invoice_postal_code: 'Invoice postal code',
		invoice_city: 'Invoice city',
		invoice_state: 'Invoice state',
		invoice_country: 'Invoice country',
		invoice_vat: 'Invoice VAT n°'
	},
	gift: {
		lastname: 'Last Name (姓)',
		firstname: 'First Name (名)',
		postalcode: 'Postal Code (郵便番号)',
		prefecture: 'Prefecture (都道府県)',
		city: 'City (市区町村)',
		address: 'Address (住所)',
		company: 'Company Name (会社名)',
		building: 'Building, Room number (建物名, 部屋番号など)',
		phone: 'Phone (電話番号)'
	},
	config: {
		comments: 'Add your dietary restrictions and allergies here'
	},
	contact: {
		firstname: 'First name',
		lastname: 'Last name',
		email: 'Email address',
		message: 'Message',
		submit: 'Submit',
		thanks: 'Thanks for your message.'
	},
	keepmeinformed: {
		firstname: 'First name',
		lastname: 'Last name',
		email: 'Email address',
		company: 'Company',
		country: 'Country',
		submit: 'Submit',
		thanks:
			'<h3>Thank you!</h3><br><p>Your subscription has been successfully registered.</p>'
	},
	subscribe: {
		firstname: 'First name',
		lastname: 'Last name',
		email: 'Email address',
		agreement: 'I agree with the General terms & conditions.',
		submit: 'Subscribe',
		thanks: {
			title: 'Thank you!',
			text: '<p>Your subscription has been successfully registered.</p>'
		}
	},
	filters: {
		title: 'Filters',
		clear: 'Clear filters',
		noresults: {
			title: 'No results found!',
			text:
				'Sorry, that filter combination has no results. Please try different criteria or clear filters.'
		}
	},
	error404: {
		title: '404',
		subtitle: 'Page not found!',
		text:
			'<p>The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.</p>',
		btn: 'Back to home'
	},
	cookies: {
		text: 'This website uses cookies to improve your browsing experience.',
		accept: 'Accept cookies',
		decline: 'Decline cookies',
		placeholder: {
			text: 'Accept marketing-cookies to display this content.',
			button: 'Cookie settings'
		}
	},
	popup: {
		bio: 'Biography'
	},
	carousel: {
		index_arialabel: 'Carousel: Go to specific index'
	},
	error:
		'Sorry, there was a problem while processing your order. Please try again later or contact us.'
}
